(function () {
  'use strict';

  function track(event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: event });
  }

  function initForm(wrapper) {
    var sid      = wrapper.dataset.piSid;
    var endpoint = wrapper.dataset.piEndpoint;

    var btn         = document.getElementById('PISubmit-'         + sid);
    var successEl   = document.getElementById('PISuccess-'        + sid);
    var errorEl     = document.getElementById('PIError-'          + sid);
    var wsSelect    = document.getElementById('PIWorkstations-'   + sid);
    var wsNote      = document.getElementById('PIWorkstationsNote-' + sid);
    var fileInput   = document.getElementById('PIFile-'           + sid);
    var fileLabel   = document.getElementById('PIFileLabel-'      + sid);
    var fileChosen  = document.getElementById('PIFileChosen-'     + sid);
    var fileName    = document.getElementById('PIFileName-'       + sid);
    var fileTrigger = fileLabel;

    var startTracked = false;
    wrapper.addEventListener('input', function () {
      if (startTracked) return;
      startTracked = true;
      track('intake_form_start');
    }, true);

    if (wsSelect && wsNote) {
      wsSelect.addEventListener('change', function () {
        var isSmall = wsSelect.value.indexOf('1-5') === 0;
        wsNote.style.display = isSmall ? 'block' : 'none';
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var file = fileInput.files[0];
        if (!file) return;
        if (fileLabel)  fileLabel.textContent = 'Change file';
        if (fileName)   fileName.textContent  = file.name;
        if (fileChosen) fileChosen.classList.add('is-visible');
      });

      if (fileTrigger) {
        fileTrigger.addEventListener('dragover', function (e) {
          e.preventDefault();
          fileTrigger.style.borderColor     = '#CD0707';
          fileTrigger.style.backgroundColor = '#fff5f5';
        });
        ['dragleave', 'drop'].forEach(function (evt) {
          fileTrigger.addEventListener(evt, function (e) {
            e.preventDefault();
            fileTrigger.style.borderColor     = '';
            fileTrigger.style.backgroundColor = '';
            if (evt === 'drop' && e.dataTransfer && e.dataTransfer.files.length) {
              fileInput.files = e.dataTransfer.files;
              fileInput.dispatchEvent(new Event('change'));
            }
          });
        });
      }
    }

    function getField(id) { return document.getElementById(id + '-' + sid); }

    function validate() {
      var required = [
        getField('PICompany'),
        getField('PIName'),
        getField('PIPhone'),
        getField('PIEmail'),
        getField('PIWorkstations')
      ];
      var valid = true;
      required.forEach(function (el) {
        if (!el) return;
        el.classList.remove('pi--invalid');
        var empty = el.value.trim() === '' || el.value === '';
        var badEmail = el.type === 'email' && el.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value);
        if (empty || badEmail) {
          el.classList.add('pi--invalid');
          valid = false;
        }
      });
      return valid;
    }

    if (!btn) return;

    // 2026-09-16 fix: the wrapper is a <div>, not a <form>, so 'submit' never fired. Listen on the button click.
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      if (btn.disabled) return;
      successEl.classList.remove('is-visible');
      errorEl.classList.remove('is-visible');

      if (!validate()) {
        var firstInvalid = wrapper.querySelector('.pi--invalid');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      var attribution = {};
      var oaiEventId = 'mof-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 14);
      if (window.MOFAdAttribution) {
        if (typeof window.MOFAdAttribution.capture === 'function') {
          window.MOFAdAttribution.capture();
        }
        if (typeof window.MOFAdAttribution.get === 'function') {
          attribution = window.MOFAdAttribution.get() || {};
        }
        if (typeof window.MOFAdAttribution.createEventId === 'function') {
          oaiEventId = window.MOFAdAttribution.createEventId();
        }
      }

      var data = new FormData();
      data.append('_subject', 'New project inquiry from the Miramar Office Furniture website');
      data.append('Source Page', window.location.pathname);
      if (document.title) data.append('Source Page Title', document.title);

      var attributionFields = {
        source_lane:  'Ad Source Lane',
        utm_source:   'UTM Source',
        utm_medium:   'UTM Medium',
        utm_campaign: 'UTM Campaign',
        utm_id:       'UTM Campaign ID',
        utm_term:     'UTM Term',
        utm_content:  'UTM Content',
        oppref:       'OpenAI Oppref',
        oai_campaign_id:   'OpenAI Campaign ID',
        oai_ad_group_id:   'OpenAI Ad Group ID',
        oai_ad_id:         'OpenAI Ad ID',
        oai_ad_account_id: 'OpenAI Ad Account ID',
        gclid:        'Google Click ID',
        wbraid:       'Google WBRAID',
        gbraid:       'Google GBRAID',
        landing_path: 'Attribution Landing Page',
        captured_at:  'Attribution Captured At'
      };
      Object.keys(attributionFields).forEach(function (key) {
        if (attribution[key]) data.append(attributionFields[key], String(attribution[key]));
      });
      data.append('Ad Event ID', oaiEventId);

      var fields = [
        'PICompany', 'PIName', 'PIPhone', 'PIEmail', 'PILocation',
        'PIProjectType', 'PIWorkstations', 'PIRooms', 'PIBudget',
        'PIMoveIn', 'PIExisting', 'PIInstall', 'PIBody'
      ];
      var fieldNames = {
        PICompany:      'Company Name',
        PIName:         'name',
        PIPhone:        'Phone Number',
        PIEmail:        'email',
        PILocation:     'Project Location',
        PIProjectType:  'Project Type',
        PIWorkstations: 'Number of Workstations',
        PIRooms:        'Rooms Needed',
        PIBudget:       'Budget Range',
        PIMoveIn:       'Target Installation Date',
        PIExisting:     'Existing Furniture',
        PIInstall:      'Installation Needed',
        PIBody:         'Project Description'
      };

      fields.forEach(function (key) {
        var el = getField(key);
        if (el && el.value.trim()) {
          data.append(fieldNames[key], el.value.trim());
        }
      });

      var accessWrap = document.getElementById('PIAccess-' + sid);
      if (accessWrap) {
        var checked = accessWrap.querySelectorAll('input[type=checkbox]:checked');
        if (checked.length) {
          var values = [];
          checked.forEach(function (c) { values.push(c.value); });
          data.append('Building Access', values.join(', '));
        }
      }

      // 2026-09-16: file upload not sent (Formspree plan rejects attachments); the success text asks for plans by email.

      btn.disabled = true;
      btn.classList.add('is-loading');

      fetch(endpoint, {
        method:  'POST',
        body:    data,
        headers: { 'Accept': 'application/json' }
      })
      .then(function (res) {
        if (!res.ok) throw new Error('error');
        return res.json();
      })
      .then(function () {
        track('intake_form_submit');

        successEl.classList.add('is-visible');
        successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        var inputs = wrapper.querySelectorAll('input:not([type=file]):not([type=checkbox]), select, textarea');
        inputs.forEach(function (el) { el.value = ''; });
        var boxes = wrapper.querySelectorAll('input[type=checkbox]');
        boxes.forEach(function (el) { el.checked = false; });
        if (fileInput)  fileInput.value = '';
        if (fileLabel)  fileLabel.textContent = 'Choose file or drag & drop';
        if (fileChosen) fileChosen.classList.remove('is-visible');
        if (wsNote)     wsNote.style.display = 'none';

        if (window.MOFOpenAIPixel && typeof window.MOFOpenAIPixel.measureLead === 'function') {
          window.MOFOpenAIPixel.measureLead(oaiEventId);
        }
      })
      .catch(function () {
        errorEl.classList.add('is-visible');
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
    });
  }

  function init() {
    var wrappers = document.querySelectorAll('[data-pi-sid]');
    if (wrappers.length && window.location.pathname !== '/') {
      document.querySelectorAll('a[href="/#project-intake-form"]').forEach(function (a) {
        a.setAttribute('href', '#project-intake-form');
      });
    }
    wrappers.forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
